import React from 'react';
import PropTypes from 'prop-types';

import { ListItem as MUIListItem } from '@mui/material';

import { ListItemButton } from './ListItemButton';

// v6 removed ListItem's deprecated `button` prop entirely — in v5 it silently rendered a
// ListItemButton internally; now the caller must render ListItemButton directly. Restored
// here so the 2 real consumers using `<ListItem button onClick={...}>` keep working
// unchanged — ListItemButton accepts the same classes/style/onClick/aria shape.
//
// Rendering ListItemButton alone (rather than nested inside a real MUIListItem) drops the
// `<li>` wrapper: when used inside a `<List>` (`<ul>`), its root element - a `<div>`, or an
// `<a>` when `component={Link}` is passed - becomes an invalid direct child of `<ul>`. Nest it
// inside a `disablePadding` ListItem so the list keeps valid `<ul>/<li>` structure for
// assistive tech, matching ListItemButton's own padding so the visual result is unchanged.
export const ListItem = ({ button = false, children, ...props }) => (
  button
    ? (
      <MUIListItem disablePadding>
        <ListItemButton {...props}>{children}</ListItemButton>
      </MUIListItem>
    )
    : <MUIListItem {...props}>{children}</MUIListItem>
);

ListItem.propTypes = {
  alignItems: PropTypes.oneOf(['flex-start', 'center']),
  button: PropTypes.bool,
  children: PropTypes.node,
  classes: PropTypes.object,
  component: PropTypes.elementType,
  dense: PropTypes.bool,
  disableGutters: PropTypes.bool,
  disabled: PropTypes.bool,
  divider: PropTypes.bool,
  selected: PropTypes.bool
};

export default ListItem;
